import { createSelector } from '@reduxjs/toolkit';

import { PARTNERS_IDS } from 'constants/partners';

import type { SliceStateFromReducer } from 'shared/types';

import type { whiteLabelSlice } from './whiteLabels.model';

export type TWhiteLabelsStore = SliceStateFromReducer<typeof whiteLabelSlice>;

export const whiteLabelAffIdSelector = (state: TWhiteLabelsStore) => state.whiteLabel.wl?.affId || undefined;
export const whiteLabelOfferIdSelector = (state: TWhiteLabelsStore) => state.whiteLabel.wl?.offerId || undefined;
export const whiteLabelThemeSelector = (state: TWhiteLabelsStore) => state.whiteLabel.wl.themePalette || '';
export const collectWLOtherDataSelector = (state: TWhiteLabelsStore) => {
  const { wl } = state.whiteLabel;
  if (wl?.affId === PARTNERS_IDS.avito) {
    return {
      externalUserId: wl?.externalUserId,
      entryPoint: wl?.entryPoint,
      affId: wl?.affId?.toString(),
      offerId: 1580,
      source: 8885,
    };
  }

  return {};
};

export const isWLSelector = (state: TWhiteLabelsStore) => state.whiteLabel?.isWL;
export const isWLServerFormValidSelector = (state: TWhiteLabelsStore) => state.whiteLabel?.isServerFormValid;
export const wlBlockFFSelector = (state: TWhiteLabelsStore) => state.whiteLabel?.blockFF;

export const isWLAvitoSelector = createSelector(whiteLabelAffIdSelector, (affId) => affId === PARTNERS_IDS.avito);
export const isWLBipSelector = createSelector(whiteLabelAffIdSelector, (affId) => affId === PARTNERS_IDS.bip);
